import BaseFormPresenter from "../../base/BaseFormPresenter";

class ApplicationFormPresenter extends BaseFormPresenter {
  constructor(view, upsertUseCase, getObjectUseCase) {
    super();
    this.view = view;
    this.upsertUseCase = upsertUseCase;
    this.getObjectUseCase = getObjectUseCase;
    this.personal = {};
    this.employmentBackground = [];
    this.characterref = [];
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = { include: ["all", "characterReferences"] };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        console.log("this.is.it", this.object);
        this.view.hideProgress();
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async assignSubmit() {
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const id = this.object.id || this.view.getObjectId();
    console.log("user", user);

    if (id) {
      this.object.recruiter = { id: id };
      console.log("Send", this.object);
      // await this.upsertUseCase.execute(collection, this.object);
    }
  }
}

export default ApplicationFormPresenter;
